module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0100.jpg?v=ffe01a52";